import axios from "axios";
import React, { useState, useEffect } from "react";
import { Container, Form, Col, Row, Spinner, Button } from "react-bootstrap";
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import { toast } from 'react-toastify';


import 'react-datepicker/dist/react-datepicker.css';
import { useForm, Controller } from "react-hook-form";
import { URL_EMPLOYEE } from "../../constans/servidor";

let myData = [];

const DesengancheFechaCorte = props => {
  const { Terminales } = props
  console.log("Terminales", Terminales);
  const [loadingData, setLoadingData] = useState(false);
  const [loading, setLoading] = useState(true);
  const [estado, setEstado] = useState()

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors }
  } = useForm()

  function reloadPage() {
    window.location.reload();
  }

  const resultData = async (myObjet) => {
    try {
      const result = await axios.post(`${URL_EMPLOYEE}/desenganchadas/solicitudFechaCorte`, myObjet)
      if (result.data['status']) {
        console.log(result.data['status']);
        toast.success(result.data['message'])
        setLoadingData(false)
        setInterval(reloadPage, 2000);
      } else {
        toast.error(result.data['data']);
        console.log(result.data['data']);
        setLoadingData(false)
      };

    } catch (error) {
      console.log("error: " + error);
      toast.error('Algo salio mal..');
      setLoadingData(false)
    }
  }

  const onSubmit = async (data) => {
    setLoadingData(true)
    try {
      let solicitadoPor = data.nombre
      console.log(solicitadoPor, "xdxdxx");

      let fechaSeleccionada = new Date(data.solicitud);
      let anio = fechaSeleccionada.getFullYear();
      let mes = fechaSeleccionada.getMonth() + 1;
      let dia = fechaSeleccionada.getDate();
      let fechaCorte = anio + "-" + (mes < 10 ? "0" + mes : mes) + "-" + (dia < 10 ? "0" + dia : dia);
      let myObjet = {
        cod_park: data.terminales.value,
        fechaCorte,
        solicitadoPor
      }

      myData.push(myObjet)
      await resultData(myData);

    } catch (error) {
      console.log("ERROR " + error);
      toast.error('Algo salio mal..');
      setLoading(false)
    }

  }

  useEffect(() => {
    const terminalesListos = Terminales != null && Array.isArray(Terminales)
    if (terminalesListos) {
      const timer = setTimeout(() => setLoading(false), 400)
      return () => clearTimeout(timer)
    } else {
      setLoading(true)
    }
  }, [Terminales])


  return loading || Terminales === null || Terminales === undefined ? (
    <div className="cargando">
      <div className="loader" id="loader">
        Loading...
      </div>
    </div>
  ) : (
    <>
      <Container >
        <form onSubmit={handleSubmit(onSubmit)}>
          {Terminales ? (
            <Row className="contenedorS-FiltradoT">
              <Col className="ColN">
                <Form.Group controlId="formBasicEmail">
                  <Form.Label className='texto-label'>Parqueadero</Form.Label>
                  <Controller
                    name='terminales'
                    control={control}
                    rules={{
                      required: {
                        value: true,
                        message: 'El campo es obligatorio',
                      }
                    }}
                    defaultValue=''
                    render={({ field: { onChange, onBlur, value } }) => (
                      <Select
                        onChange={(data) => {
                          onChange(data);
                        }}
                        value={value}
                        options={Terminales}
                      />

                    )}
                  />
                  {errors.terminales && (
                    <Form.Text id="passwordHelpBlock" className="error">
                      El campo es obligatorio
                    </Form.Text>
                  )}
                </Form.Group>
                <Form.Group controlId="formBasicEmail">
                  <Form.Label className='texto-label'>Fecha de Solicitud</Form.Label>
                  <Controller
                    name="solicitud"
                    control={control}
                    rules={{ required: true }}
                    defaultValue={new Date()}
                    render={({ field: { onChange, onBlur, value } }) => (
                      <DatePicker
                        className="form-control"
                        selected={value}
                        dateFormat="yyyy-MM-dd"
                        onChange={(date) => onChange(date)}
                      />
                    )}
                  />
                </Form.Group>
                <Form.Group className="inputmayuscula">
                  <Form.Label className='texto-label'>Nombre Solicitante</Form.Label>
                  <Controller
                    name="nombre"
                    control={control}
                    defaultValue="Sandra Rodriguez"
                    render={({ field: { onChange, onBlur, value } }) => (
                      <Form.Control
                        type="text"
                        onBlur={onBlur}
                        onChange={(value) => onChange(value)}
                        value={value}
                        disabled={true}
                      />
                    )}
                  />
                </Form.Group>
              </Col>
            </Row>
          ) : null}
          <Row className="justify-content-end mbottom-20">
            <Button type="submit" variant="primary" className=" btn btn-primary mtop-20 boton"
            >
              {loadingData ? (
                <Spinner animation="border" size="sm" />
              ) : (
                'Desenganchar por fecha de corte'
              )}
            </Button>
          </Row>
        </form>
      </Container>
    </>
  )

}

export default DesengancheFechaCorte;